const _0 = "0px"
const _1 = "0.25rem"
const _2 = "0.5rem"
const _3 = "0.75rem"
const _4 = "1rem"
const _5 = "1.25rem"
const _6 = "1.5rem"
const _7 = "1.75rem"
const _8 = "2rem"
const _9 = "2.25rem"
const _10 = "2.5rem"
const _11 = "2.75rem"
const _12 = "3rem"
const _14 = "3.5rem"
const _15 = "3.75rem"
const _16 = "4rem"
const _20 = "5rem"
const _24 = "6rem"
const _25 = "6.25rem"
const _28 = "7rem"
const _32 = "8rem"
const _36 = "9rem"
const _40 = "10rem"
const _44 = "11rem"
const _48 = "12rem"
const _52 = "13rem"
const _56 = "14rem"
const _60 = "15rem"
const _64 = "16rem"
const _72 = "18rem"
const _80 = "20rem"
const _96 = "24rem"
const _px = "1px"
const _small = "18px"
const _none = "none"
const _xs = "20rem"
const _sm = "24rem"
const _md = "28rem"
const _lg = "32rem"
const _xl = "36rem"
const _2xl = "42rem"
const _3xl = "48rem"
const _4xl = "56rem"
const _5xl = "64rem"
const _6xl = "72rem"
const _7xl = "80rem"
const _full = "100%"
const _min = "min-content"
const _max = "max-content"
const _fit = "fit-content"
const _prose = "65ch"
const config = { "0": _0, "1": _1, "2": _2, "3": _3, "4": _4, "5": _5, "6": _6, "7": _7, "8": _8, "9": _9, "10": _10, "11": _11, "12": _12, "14": _14, "15": _15, "16": _16, "20": _20, "24": _24, "25": _25, "28": _28, "32": _32, "36": _36, "40": _40, "44": _44, "48": _48, "52": _52, "56": _56, "60": _60, "64": _64, "72": _72, "80": _80, "96": _96, "px": _px, "small": _small, "none": _none, "xs": _xs, "sm": _sm, "md": _md, "lg": _lg, "xl": _xl, "2xl": _2xl, "3xl": _3xl, "4xl": _4xl, "5xl": _5xl, "6xl": _6xl, "7xl": _7xl, "full": _full, "min": _min, "max": _max, "fit": _fit, "prose": _prose, "0.5": "0.125rem", "1.5": "0.375rem", "2.5": "0.625rem", "3.5": "0.875rem", "4.5": "1.125rem", "1/2": "50%", "9/16": "56.25%", "1/12": "8.333333%", "line-2": "2px", "line-4": "4px", "line-6": "6px", "screen-sm": "640px", "screen-md": "768px", "screen-lg": "1024px", "screen-xl": "1280px", "screen-2xl": "1536px", "screen-navigation-adjustment": "1120px", "screen-chart-adjustment": "1260px", "screen-header-breakpoint": "1280px", "form-container": "320px", "video-container": "1240px", "article-container": "678px", "content-container": "1424px", "newsletter-container": "1536px", "1/3": "33.33333%", "2/3": "66.66666%",  }
export { config as default, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _14, _15, _16, _20, _24, _25, _28, _32, _36, _40, _44, _48, _52, _56, _60, _64, _72, _80, _96, _px, _small, _none, _xs, _sm, _md, _lg, _xl, _2xl, _3xl, _4xl, _5xl, _6xl, _7xl, _full, _min, _max, _fit, _prose }